import memoize from "memoizee";
import FreespaceError from "./FreespaceError";

class FreespaceClient {
  authKey;

  base;

  analyticsApi;

  heartbeatBase;

  lastBeatTime;

  timeOffset;

  signageCmsBase;

  bearerToken;

  constructor(authKey, base, analyticsApi, heartbeatBase, signageCmsBase, bearerToken) {
    this.authKey = authKey;
    this.base = base;
    this.analyticsApi = analyticsApi;
    this.devbase = "https://accountws4.dev.afreespace.com";
    this.heartbeatBase = heartbeatBase;
    this.signageCmsBase = signageCmsBase || "https://signagecms.dev.afreespace.com";
    this.bearerToken = bearerToken;
    this.lastBeatTime = 0;
    this.timeOffset = 0;
    this._fetch = memoize(this.fetchNoCache.bind(this), { promise: true });
    this.get = memoize(this.getNoCache.bind(this), { promise: true });
    this.post = memoize(this.postNoCache.bind(this), { promise: true });
    this.signageGet = memoize(this.signageGetNoCache.bind(this), { promise: true });
  }

  fetchNoCache(url, options) {
    return fetch(url, options).then((response) => {
      if (!response.ok) {
        return response.json().then(
          (json) => {
            throw new FreespaceError(response, json);
          },
          () => {
            // Response is not even JSON
            throw new FreespaceError(response);
          }
        );
      }
      return response.json();
    });
  }

  getNoCache(url) {
    return this._fetch(url, {
      headers: {
        "X-Auth-Key": this.authKey,
      },
    });
  }

  postNoCache(url, payload) {
    return this._fetch(url, {
      headers: {
        "X-Auth-Key": this.authKey,
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(payload),
    });
  }

  signageGetNoCache(url) {
    return this._fetch(url, {
      headers: {
        "Authorization": `BEARER ${this.bearerToken}`,
        "Content-Type": "application/json",
      },
    });
  }

  updateClockOffset(serverTime) {
    if (serverTime != null && serverTime.length > 0) {
      const serverMillis = Date.parse(serverTime);
      this.timeOffset = Date.now() - serverMillis;
    }
  }

  checkHeartBeat(id, signageState) {
    if (this.heartbeatBase !== null) {
      const time = Date.now();
      const self = this;
      fetch(`${this.heartbeatBase}/heartbeat/${this.authKey}/${time}/${signageState.isLoading}`).then((response) => {
        if (response.ok) {
          self.lastBeatTime = Date.now();
          const serverTime = response.headers.get("date");
          self.updateClockOffset(serverTime);
        }
      });
      signageState.healthStatusIndex = this.getHealthStatus();
    }
    signageState.timeOffset = this.timeOffset;
    return true;
  }

  fetchSignage(id) {
    return this.get(`${this.base}/api/admin/displays/${id}`);
  }

  fetchHistoricDemand(payload) {
    return this.post(`${this.analyticsApi}/api/occupancy/time`, payload);
  }

  fetchLocations(ids) {
    return this.get(`${this.base}/api/locations/${ids.join(",")}`);
  }

  fetchSpacesByLocations(ids) {
    return this.get(`${this.base}/api/locations/${ids.join(",")}/spaces`);
  }

  fetchSpaceStatesByLocations(ids) {
    return this.getNoCache(`${this.base}/api/locations/${ids.join(",")}/spaces/states`);
  }

  fetchgetAmenityRequests(ids, date, Group) {
    return this.getNoCache(`${this.base}/api/compliance/admin/spaceAllocation?locationId=${ids}&date=${date}`);
  }

  fetchAllElementsByDisplayId(id, signageId) {
    // return new Promise((resolve, reject) => {
    //   resolve(floorelement[id])
    // });
    return this.get(`${this.base}/displays/${id}/allelements`);
  }

  fetchGraphByDisplayId(id) {
    // return new Promise((resolve, reject) => {
    // resolve(graph[id]);
    return this.get(`${this.base}/displays/${id}/graph`);
    // })
  }

  fetchCategories() {
    return this.get(`${this.base}/api/admin/desktypes`);
  }

  getHealthStatus() {
    const diff = (Date.now() - this.lastBeatTime) / (60 * 1000);
    console.info("Diff", diff);
    return diff < 2 ? 0 : diff < 10 ? 1 : 2;
  }

  static loginUsingHash(hash) {
    // @todo We will implement this later as right now we can read the key from the local storage
  }

  async getMeetingRoom(locationId) {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer eyJhbGciOiJSUzI1NiJ9.eyJ1dHAiOiJVIiwidHRwIjoiQUNDIiwic3ViIjoiMjA3NzYiLCJhdWQiOiJodHRwczovL2FkbWluLXRlbXAuYWZyZWVzcGFjZS5jb20vP3JlZGlyZWN0X3RvPWh0dHBzJTNBJTJGJTJGYWRtaW4tdGVtcC5hZnJlZXNwYWNlLmNvbSUyRnNjcmVlbi1saXN0Lmh0bWwiLCJleHAiOjE3MTQ2MzM4ODQsImFpZCI6MTIsImlhdCI6MTcxMzk4NTg4NH0.c6XJYwxQIiR2v2o9SbjoFtrhbHjC3Ui8iHdkd1_nGNh3Mwhjl9VNb9SvGENDeCoa8mqshLdvshf9mQBF7kIDk9U3ulY9b7X8zfz5oBSJV8E3OluJj44faHBearA38Pr7fasuwworO6Y9m1FBJrMNKj9ic0yucGGNNSG_HxSl6XihFKsnu2TEBkjfzFB3cAh_PObYwOp--xxUw-6fmQhN6_WK-XHuuJ4p4O8ZCDFjuOC4dklH9nPXBWdG5VAUPYStU9YBF_54fJ4zyRWWHCA1hE58F5VuDvBqfqjMGSxPFOtM03bWp-csK9TgracNY1w4yEyTt5L01578PlmHwhedRw`);
    myHeaders.append("Content-Type", "application/json");
    var graphql = JSON.stringify({
      query: `query {
        spacesOnFloor(locationId: ${locationId}, all: false, date: 20230710, type: WORK_SPACE, wsType: "Meeting Room") {
          id
          name
          showOnFloor
          available
          capacity
          imageUrl
          category {
            name
          }
          deskAttributes {
            name
            id
          }
        }
      }
      `,
      variables: {},
    });
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: graphql,
      redirect: "follow",
    };

    const result = await fetch("https://user-app-api.afreespace.com/graphql", requestOptions)
      .then((response) => response.text())
      .then((result) => result)
      .catch((error) => console.log("error API DATA", error));
    return JSON.parse(result).data.spacesOnFloor;
  }

  // Signage CMS API methods
  fetchSignageDesignVersion(screenId) {
    return this.signageGet(`${this.signageCmsBase}/design/screen/${screenId}/version`);
  }

  fetchSignageComponentLibrary() {
    return this.signageGet(`${this.signageCmsBase.replace('dev', 'integration')}/react-component`);
  }

  // Update bearer token if needed
  updateBearerToken(token) {
    this.bearerToken = token;
  }
}

export default FreespaceClient;
